module.exports = __webpack_public_path__ + "img/人体姿态.b4d7276d.png";